import { Cable, Wrench, Recycle, ShieldCheck, Moon, Server } from 'lucide-react';
import SeriesTemplate from '../components/SeriesTemplate';

const AnalogCamera = () => {
  const features = [
    {
      Icon: Cable,
      title: '既存同軸配線を活用',
      desc: 'AHD/TVI/CVI規格に対応し、既存のアナログ配線を活かした入れ替えが可能です。',
    },
    {
      Icon: Wrench,
      title: '導入コストを抑えた入れ替え',
      desc: '既設カメラを入れ替えるだけで映像品質を改善できるケースがあります。',
    },
    {
      Icon: Recycle,
      title: '古い設備の更新に有効',
      desc: '長年使用しているアナログ設備の更新・拡張に向いています。',
    },
    {
      Icon: ShieldCheck,
      title: '屋内外対応モデル',
      desc: 'ドーム型・バレット型・屋外対応モデルまで、複数の形状を選べます。',
    },
    {
      Icon: Moon,
      title: '赤外線対応モデル',
      desc: '暗所や夜間の撮影にも対応するモデルがあります。',
    },
    {
      Icon: Server,
      title: 'DVR録画機器と連携',
      desc: 'アナログ対応の録画機器と組み合わせて、シンプルな録画構成を作れます。',
    },
  ];

  const notes = [
    '既存配線の状態・距離・接続端子により、入れ替え可否が変わります。事前確認が必要です。',
    'IPカメラと比較すると解像度・機能に制限があります。用途に応じてご相談ください。',
    '屋外設置の場合は、配線経路・取付位置・防水処理の確認が必要です。',
    '機種や設定内容により、使用できる機能が異なる場合があります。',
  ];

  return (
    <SeriesTemplate
      id="analog"
      eyebrow="ANALOG CAMERA"
      name="Analogカメラシリーズ"
      description="既存配線を活かした入れ替えや、費用を抑えた導入に向いた防犯カメラシリーズです。現在の設備状況を確認しながら最適な構成を選定します。"
      tags={['AHD / TVI / CVI', '4MP', '赤外線', '屋内外対応', '既存配線活用']}
      features={features}
      locations={['既存設備の入れ替え', '費用重視の導入', '倉庫・工場', '駐車場（既存配線あり）', '小規模施設']}
      notes={notes}
    />
  );
};

export default AnalogCamera;
